var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddBookmark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 44,
    viewBox: "0 0 43 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.3427 21.1096L20.4056 21.1096L20.4056 16.1726",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4685 21.1096H20.4056L20.4056 26.0467",
    stroke: "white",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.9069 37.438L12.9047 37.4383C10.8006 37.7541 9.23698 37.3937 7.90517 36.6896C6.55056 35.9735 5.41798 34.8952 4.17778 33.7124C3.05804 32.6356 2.51721 30.9828 2.43826 29.3178C2.35893 27.6447 2.75148 26.0781 3.36053 25.2142C3.97283 24.3457 4.65431 23.6725 5.35179 22.9834C5.63524 22.7034 5.92133 22.4208 6.20649 22.1214C7.17677 21.1027 8.06054 19.9526 8.49328 18.2233C8.7931 17.0251 8.85746 15.8065 8.92156 14.5928C8.94644 14.1215 8.97129 13.651 9.00986 13.1827C9.15024 11.4785 9.4704 9.66255 10.5814 7.56137C11.7777 5.29898 13.878 3.93064 17.1005 3.3851C19.6749 2.94927 21.5229 3.56984 24.1084 4.69927C25.8264 5.44975 26.797 6.82927 29.0062 10.3103C30.0999 12.0336 31.7328 13.1314 33.2565 14.1558C33.3487 14.2178 33.4405 14.2795 33.5318 14.3411C35.1623 15.4412 36.6347 16.5016 37.4903 18.2078C38.5598 20.3403 38.488 22.9245 37.8073 25.2934C37.1257 27.6657 35.8595 29.7296 34.6642 30.7964C33.5682 31.7746 32.1463 32.0997 30.3324 32.2752C29.822 32.3246 29.2786 32.362 28.708 32.4012C27.2939 32.4983 25.7131 32.6069 24.0538 32.9391C21.7321 33.4037 19.9987 34.3698 18.3709 35.277C18.3269 35.3015 18.283 35.326 18.2391 35.3504C16.5657 36.2824 14.9931 37.1344 12.9069 37.438Z",
    stroke: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBookmark);
export default __webpack_public_path__ + "static/media/add-bookmark.3d0d0730a9df3a0ad06567a12adc7b39.svg";
export { ForwardRef as ReactComponent };